import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Goatopunecab() {



  const cardData = {




keyword: "Goa to Pune Cabs",

headingDescription: "Garud Cab Service provides comfortable and dependable Goa to Pune Cab Service for families, couples, corporate travelers, students, groups, and passengers returning from Goa to Pune. We offer chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, and premium vehicles for one-way, round-trip, and customized travel requirements. With experienced drivers, clean and well-maintained cars, flexible pickup arrangements, spacious luggage facilities, transparent pricing, and 24/7 customer assistance, we make the long-distance journey from Goa to Pune smooth and convenient. Whether you are returning from a beach vacation, traveling for business, visiting relatives, or planning a comfortable intercity trip, Garud Cab Service provides a safe and hassle-free travel experience.",

topPlaces: [
  {
    title: "Shaniwar Wada Pune",
    description: "Shaniwar Wada is one of Pune's most famous historical landmarks and an important part of the city's Maratha heritage. The impressive fortification, historic gateways, courtyards, and surrounding old-city atmosphere attract tourists throughout the year. Travelers arriving in Pune from Goa can conveniently visit Shaniwar Wada as part of a city sightseeing plan."
  },
  {
    title: "Aga Khan Palace Pune",
    description: "Aga Khan Palace is a prominent historical monument in Pune known for its beautiful architecture, landscaped gardens, and important connection with India's freedom movement. The peaceful surroundings make it an interesting destination for families, history enthusiasts, and tourists. Visitors can easily include the palace in a Pune sightseeing itinerary after their Goa to Pune journey."
  },
  {
    title: "Sinhagad Fort Pune",
    description: "Sinhagad Fort is a scenic hill fort located near Pune and is famous for its historic importance, mountain views, trekking routes, and traditional Maharashtrian food. It is a popular weekend destination for families, friends, and adventure enthusiasts. Travelers arriving from Goa can hire a private cab for a comfortable visit to the fort and surrounding hills."
  },
  {
    title: "Dagdusheth Halwai Ganpati Temple Pune",
    description: "Dagdusheth Halwai Ganpati Temple is one of Pune's most renowned religious landmarks and attracts devotees throughout the year. The beautifully decorated temple and its central location make it an important stop for visitors exploring Pune's cultural and spiritual heritage. Goa travelers can include the temple in their city tour after reaching Pune."
  },
  {
    title: "Pataleshwar Cave Temple Pune",
    description: "Pataleshwar Cave Temple is an ancient rock-cut temple located in central Pune and dedicated to Lord Shiva. The historic cave structure, stone carvings, and peaceful surroundings provide a unique spiritual and heritage experience within the city. It is convenient for travelers looking for a short sightseeing stop during their Pune visit."
  },
  {
    title: "Parvati Hill Pune",
    description: "Parvati Hill is one of Pune's popular elevated landmarks, featuring historic temples and panoramic views across the city. The location combines spirituality, heritage, and scenic surroundings and is especially attractive around sunrise and sunset. Travelers from Goa can include Parvati Hill in a flexible Pune sightseeing itinerary."
  },
  {
    title: "Pashan Lake Pune",
    description: "Pashan Lake is a peaceful natural attraction in Pune surrounded by greenery and walking areas. It is suitable for visitors looking for a relaxed outdoor experience away from busy commercial areas. Families, couples, and nature lovers arriving from Goa can visit the lake as part of a leisurely Pune city tour."
  },
  {
    title: "Khadakwasla Dam Pune",
    description: "Khadakwasla Dam is a popular recreational destination on the outskirts of Pune, known for its reservoir, surrounding hills, scenic roads, and pleasant atmosphere. It is frequently visited during weekends by families and groups. Travelers arriving in Pune can combine Khadakwasla with Sinhagad and other nearby attractions for a convenient day trip."
  },
  {
    title: "Empress Garden Pune",
    description: "Empress Garden is a historic green space in Pune featuring large trees, landscaped areas, flowering plants, and peaceful walking paths. It offers visitors a relaxing break from the city's busy surroundings and is suitable for families and nature lovers. It can be easily included in a Pune local sightseeing itinerary."
  },
  {
    title: "Raja Dinkar Kelkar Museum Pune",
    description: "Raja Dinkar Kelkar Museum houses an extensive collection of traditional Indian art, crafts, sculptures, musical instruments, household objects, and cultural artifacts. It provides visitors with an interesting insight into India's artistic heritage. Travelers returning from Goa can explore the museum as part of a cultural sightseeing tour in Pune."
  }
],



"services": [
{
"name": "Goa to Pune Cab",
"description": "Book Goa to Pune Cab for comfortable, reliable, and convenient intercity transportation with professional chauffeurs and well-maintained AC vehicles. Choose from Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and premium cab options for family trips, business travel, sightseeing, personal visits, airport transfers, one-way drops, and round-trip journeys."
},
{
"name": "Goa to Pune Cab Service",
"description": "Choose Goa to Pune Cab Service for dependable private transportation between Goa and Pune with experienced chauffeurs, clean interiors, spacious seating, and convenient pickup arrangements. The service is suitable for families, tourists, corporate travelers, individuals, and groups planning comfortable one-way or return journeys."
},
{
"name": "Goa to Pune One Way Cab",
"description": "Reserve Goa to Pune One Way Cab for a direct point-to-point journey without arranging a return trip. Enjoy private AC transportation, professional chauffeur service, flexible pickup from hotels, resorts, homes, airports, or other locations in Goa, and suitable vehicle choices for different passenger and luggage requirements."
},
{
"name": "Goa to Pune Taxi",
"description": "Hire Goa to Pune Taxi for a smooth and private road journey with courteous chauffeurs, comfortable AC vehicles, and convenient pickup and drop facilities. The service is suitable for family travel, business visits, tourist journeys, airport transfers, personal trips, and passengers looking for reliable transportation from Goa to Pune."
},
{
"name": "Goa to Pune Cab Price",
"description": "Check Goa to Pune Cab Price according to your selected vehicle, passenger count, luggage requirements, and journey type. Choose economical Sedan and Swift Dzire cars or spacious Ertiga, Innova, Innova Crysta, Kia Carens, and SUV options for comfortable chauffeur-driven transportation."
},
{
"name": "Goa Pune Cab Service",
"description": "Book Goa Pune Cab Service for convenient and comfortable intercity travel with professional drivers, clean AC vehicles, spacious seating, and flexible pickup arrangements. The service can be planned for family trips, corporate travel, sightseeing, personal visits, airport transfers, one-way journeys, and scheduled return transportation."
},
{
"name": "Goa to Pune Car Rental",
"description": "Hire Goa to Pune Car Rental with a professional chauffeur for a comfortable long-distance journey without the stress of driving yourself. Select from Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and premium vehicles according to your group size, luggage requirements, comfort preferences, and travel schedule."
},
{
"name": "Goa to Pune Taxi Fare",
"description": "Get Goa to Pune Taxi Fare details with flexible vehicle categories for different budgets and passenger requirements. Choose economical sedans or spacious Ertiga, Innova, Innova Crysta, Kia Carens, and SUV cabs while planning one-way, round-trip, family, corporate, tourist, or airport transportation."
},
{
"name": "Goa to Pune Cabs",
"description": "Reserve Goa to Pune Cabs for dependable private road transportation with experienced chauffeurs and comfortable air-conditioned vehicles. Multiple vehicle categories are available for individuals, families, groups, tourists, and corporate passengers requiring convenient pickup and direct drop between Goa and Pune."
},
{
"name": "Goa to Pune Taxi Service",
"description": "Choose Goa to Pune Taxi Service for safe and convenient intercity travel with trained chauffeurs, clean AC vehicles, comfortable seating, and flexible pickup options. The service is suitable for family journeys, business travel, sightseeing, airport transfers, hotel transfers, and personal travel requirements."
},
{
"name": "Cab from Goa to Pune",
"description": "Book a Cab from Goa to Pune for private door-to-door transportation with professional chauffeurs and well-maintained AC vehicles. Pickup can be arranged from hotels, resorts, residences, airports, railway stations, or tourist areas in Goa for a smooth journey to your preferred destination in Pune."
},
{
"name": "Taxi from Goa to Pune",
"description": "Hire a Taxi from Goa to Pune for comfortable and dependable road travel with experienced drivers and spacious air-conditioned vehicles. The service provides convenient pickup and direct drop facilities for families, solo travelers, corporate passengers, tourists, and groups traveling between Goa and Pune."
},
{
"name": "Goa to Pune Outstation Cab",
"description": "Reserve Goa to Pune Outstation Cab for long-distance travel with professional chauffeurs, clean AC interiors, spacious seating, and dependable journey arrangements. Choose a suitable Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV according to your passenger count, luggage, and comfort requirements."
},
{
"name": "Goa to Pune Car Rentals",
"description": "Choose Goa to Pune Car Rentals with chauffeur-driven vehicles for convenient and stress-free intercity transportation. Select from economical sedans, spacious MUVs, premium Innova Crysta, Kia Carens, SUVs, and other suitable vehicles for families, business travelers, tourists, and groups."
},
{
"name": "Goa to Pune Innova Cab",
"description": "Book Goa to Pune Innova Cab for a spacious and comfortable journey with generous seating, luggage capacity, AC interiors, and professional chauffeur service. Innova is a practical choice for families, small groups, corporate travelers, and passengers seeking relaxed long-distance transportation."
},
{
"name": "Goa to Pune Ertiga Cab",
"description": "Reserve Goa to Pune Ertiga Cab for comfortable family and group travel with spacious seating, useful luggage capacity, air conditioning, and an experienced chauffeur. Ertiga offers a practical combination of comfort and space for one-way trips, return journeys, business travel, and sightseeing."
},
{
"name": "Goa to Pune Sedan Cab",
"description": "Choose Goa to Pune Sedan Cab for economical and comfortable intercity travel in a clean air-conditioned vehicle with professional chauffeur service. Sedan options are suitable for individuals, couples, small families, business travelers, and passengers looking for a convenient one-way or round-trip journey."
},
{
"name": "Goa to Pune SUV Taxi",
"description": "Book Goa to Pune SUV Taxi for spacious and comfortable transportation suitable for families, groups, and passengers carrying additional luggage. Enjoy air-conditioned interiors, professional chauffeurs, convenient pickup, and reliable road travel with an SUV selected according to your journey requirements."
},
{
"name": "Goa to Pune AC Cab",
"description": "Reserve Goa to Pune AC Cab for a comfortable long-distance journey with air-conditioned interiors, clean seating, professional chauffeurs, and convenient pickup arrangements. The service is suitable for families, tourists, corporate travelers, individuals, and groups requiring private transportation between Goa and Pune."
},
{
"name": "Goa to Pune Luxury Cab",
"description": "Hire Goa to Pune Luxury Cab for a premium chauffeur-driven travel experience with refined interiors, spacious seating, air conditioning, and professional service. It is suitable for corporate executives, families, special occasions, premium travelers, and passengers seeking enhanced comfort during long-distance travel."
},
{
"name": "North Goa to Pune Cab",
"description": "Book North Goa to Pune Cab for convenient pickup from popular North Goa areas and direct transportation to Pune. Enjoy comfortable AC travel with professional chauffeurs and suitable vehicle choices for tourists, families, corporate passengers, and groups returning from Goa to Pune."
},
{
"name": "South Goa to Pune Taxi",
"description": "Reserve South Goa to Pune Taxi for a comfortable private journey from South Goa destinations to Pune. Professional chauffeurs provide convenient pickup, clean AC vehicles, spacious seating, and direct drop facilities for families, tourists, business travelers, and passengers carrying luggage."
},
{
"name": "Panaji to Pune Cabs",
"description": "Choose Panaji to Pune Cabs for dependable intercity transportation from Panaji to your preferred destination in Pune. Travel comfortably with professional chauffeurs, air-conditioned vehicles, convenient pickup, spacious luggage capacity, and vehicle options suitable for individuals, families, tourists, and corporate travelers."
},
{
"name": "Calangute to Pune Taxi",
"description": "Book Calangute to Pune Taxi for a direct and comfortable journey from Calangute to Pune with professional chauffeur service and clean AC vehicles. The service is convenient for tourists, families, couples, groups, and passengers returning from Goa holidays who require private door-to-door transportation."
},
{
"name": "Baga to Pune Cab",
"description": "Reserve Baga to Pune Cab for convenient pickup from Baga and comfortable long-distance transportation to Pune. Choose from Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and premium vehicles according to your passenger count, luggage requirements, and preferred level of comfort."
},
{
"name": "Madgaon to Pune Taxi",
"description": "Hire Madgaon to Pune Taxi for reliable private transportation from Madgaon to Pune with convenient pickup and direct destination drop. Professional chauffeurs and comfortable AC vehicles make the service suitable for families, tourists, business travelers, individuals, and groups traveling with luggage."
},
{
"name": "Goa Airport to Pune Cab",
"description": "Book Goa Airport to Pune Cab for convenient airport pickup and direct transportation to Pune. Professional chauffeurs can assist with luggage and provide comfortable AC travel in Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and premium vehicles according to passenger and luggage requirements."
},
{
"name": "Goa to Pune Cab Near Me",
"description": "Find a Goa to Pune Cab Near Me for convenient pickup from your current location in Goa and direct transportation to Pune. Enjoy private AC travel, professional chauffeur service, flexible pickup arrangements, and suitable vehicle options for individuals, families, tourists, corporate travelers, and groups."
},
{
"name": "Goa to Pune Cab Booking",
"description": "Make Goa to Pune Cab Booking for a scheduled private journey with convenient pickup and direct drop arrangements. Select your preferred travel date, pickup location, passenger capacity, luggage requirements, and vehicle category for comfortable transportation from Goa to Pune."
},
{
"name": "Goa to Pune Taxi Booking Online",
"description": "Use Goa to Pune Taxi Booking Online to arrange your intercity journey conveniently in advance. Select your pickup location, travel date, passenger count, luggage requirements, and preferred vehicle while enjoying private AC transportation, professional chauffeur service, and flexible one-way or round-trip travel options."
},
{
"name": "Goa to Pune Cab Fare",
"description": "Check Goa to Pune Cab Fare before booking and choose a vehicle according to your budget, passenger capacity, luggage requirements, and journey type. Comfortable Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and premium cab options are available for different travel needs."
},
{
"name": "Goa to Pune Taxi Fare",
"description": "Get Goa to Pune Taxi Fare information with vehicle options suitable for individuals, families, corporate travelers, tourists, and groups. Select an economical sedan or spacious Ertiga, Innova, Innova Crysta, Kia Carens, or SUV for comfortable chauffeur-driven transportation."
},
{
"name": "Goa to Pune Cab Price",
"description": "Find a competitive Goa to Pune Cab Price based on your selected vehicle, passenger requirements, luggage capacity, and travel plan. Choose from economical and premium cab categories for one-way transfers, return journeys, family travel, business trips, sightseeing, and airport transportation."
},
{
"name": "Goa to Pune Taxi Charges",
"description": "Get Goa to Pune Taxi Charges according to your selected vehicle and journey requirements. Enjoy comfortable chauffeur-driven transportation with Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, and SUV options for one-way drops, round trips, family journeys, corporate travel, sightseeing, and airport transfers."
},
{
"name": "Best Goa to Pune Cab Service",
"description": "Book the Best Goa to Pune Cab Service for dependable and comfortable intercity transportation with experienced chauffeurs, clean AC vehicles, convenient pickup, and flexible booking options. Choose Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, or premium vehicles according to your travel requirements."
},
{
"name": "Cheap Goa to Pune Cab",
"description": "Choose a Cheap Goa to Pune Cab for budget-friendly intercity transportation while maintaining essential comfort and convenience. Affordable vehicle options, professional chauffeurs, air-conditioned interiors, direct pickup, and flexible one-way or round-trip arrangements make the service suitable for individuals, families, students, tourists, and business travelers."
},
{
"name": "Goa to Pune Round Trip Taxi",
"description": "Book Goa to Pune Round Trip Taxi for convenient return transportation when your travel plan includes a journey from Goa to Pune and back. Enjoy flexible scheduling, comfortable AC vehicles, experienced chauffeurs, spacious luggage capacity, and suitable vehicle choices for family trips, corporate travel, sightseeing, and extended journeys."
}
],
"tableData": [
["Goa to Pune Cab", "Goa to Pune Cab Service"],
["Goa to Pune One Way Cab", "Goa to Pune Taxi"],
["Goa to Pune Cab Price", "Goa Pune Cab Service"],
["Goa to Pune Car Rental", "Goa to Pune Taxi Fare"],
["Goa to Pune Cabs", "Goa to Pune Taxi Service"],
["Cab from Goa to Pune", "Taxi from Goa to Pune"],
["Goa to Pune Outstation Cab", "Goa to Pune Car Rentals"],
["Goa to Pune Innova Cab", "Goa to Pune Ertiga Cab"],
["Goa to Pune Sedan Cab", "Goa to Pune SUV Taxi"],
["Goa to Pune AC Cab", "Goa to Pune Luxury Cab"],
["North Goa to Pune Cab", "South Goa to Pune Taxi"],
["Panaji to Pune Cabs", "Calangute to Pune Taxi"],
["Baga to Pune Cab", "Madgaon to Pune Taxi"],
["Goa Airport to Pune Cab", "Goa to Pune Cab Near Me"],
["Goa to Pune Cab Booking", "Goa to Pune Taxi Booking Online"],
["Goa to Pune Cab Fare", "Goa to Pune Taxi Fare"],
["Goa to Pune Cab Price", "Goa to Pune Taxi Charges"],
["Best Goa to Pune Cab Service", "Cheap Goa to Pune Cab"],
["Goa to Pune One Way Cab", "Goa to Pune Round Trip Taxi"]
],



whychoose: [
  {
    WhyChooseheading: "Goa to Pune Cab for a Comfortable Return Journey",
    WhyChoosedescription: "Garud Cab Service offers convenient Goa to Pune cabs for travellers returning from holidays, business visits, family trips, resort stays, and personal journeys who prefer a private intercity transfer."
  },
  {
    WhyChooseheading: "Pickup from Hotels, Resorts & Local Areas",
    WhyChoosedescription: "Arrange your pickup from a Goa hotel, resort, villa, beachside accommodation, residential location, or another preferred point and travel directly towards Pune."
  },
  {
    WhyChooseheading: "Direct Travel Without Changing Vehicles",
    WhyChoosedescription: "A private cab lets you travel directly from Goa to Pune without switching between buses, trains, or local transport, which can be especially convenient when travelling with family or luggage."
  },
  {
    WhyChooseheading: "One-Way Return Cab from Goa",
    WhyChoosedescription: "If your Goa holiday has ended and Pune is your next destination, book a dedicated one-way cab for a straightforward return journey according to your preferred departure time."
  },
  {
    WhyChooseheading: "Comfortable Options for Different Groups",
    WhyChoosedescription: "Garud Cab Service can arrange vehicles according to passenger count, luggage volume, and comfort needs, making the service suitable for couples, families, friends, and small groups."
  },
  {
    WhyChooseheading: "Airport, Railway Station & Hotel Transfers",
    WhyChoosedescription: "The service can be useful when connecting from Goa accommodation or local travel points to Pune, including journeys planned around airport, railway station, hotel, or business travel requirements."
  },
  {
    WhyChooseheading: "Suitable for Business & Personal Travel",
    WhyChoosedescription: "Goa to Pune cabs are useful for corporate travellers, professionals, family visits, students, tourists, and passengers returning to Pune after completing their work or holiday."
  },
  {
    WhyChooseheading: "Simple Booking with Garud Cab Service",
    WhyChoosedescription: "Share your Goa pickup location, Pune destination, travel date, passenger details, luggage requirements, and preferred vehicle to arrange a suitable return cab with Garud Cab Service."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Goa to Pune Cabs?",
    answer: "Yes, Garud Cab Service provides Goa to Pune cab services for tourists, families, corporate travellers, couples, and individuals returning from Goa."
  },
  {
    question: "Can I book a one-way cab from Goa to Pune?",
    answer: "Yes, one-way cab service is available for passengers travelling directly from Goa to Pune."
  },
  {
    question: "Can the cab pick me up from my Goa hotel?",
    answer: "Yes, pickup can be arranged from hotels, resorts, villas, residential areas, and other preferred locations in Goa."
  },
  {
    question: "Can I travel from North Goa to Pune by cab?",
    answer: "Yes, transportation can be arranged from suitable locations across North Goa to your preferred destination in Pune."
  },
  {
    question: "Can I book a cab from South Goa to Pune?",
    answer: "Yes, passengers travelling from South Goa can also arrange a private cab to Pune according to their travel schedule."
  },
  {
    question: "Which vehicles are available for Goa to Pune travel?",
    answer: "Suitable vehicle options can be arranged based on passenger count, luggage requirements, comfort preferences, and vehicle availability."
  },
  {
    question: "Is the service suitable for families with luggage?",
    answer: "Yes, families can choose a suitable vehicle according to their group size and luggage requirements for a more comfortable return journey."
  },
  {
    question: "Can corporate travellers book Goa to Pune cabs?",
    answer: "Yes, corporate passengers can use the service for business travel, meetings, work assignments, conferences, and other professional journeys."
  },
  {
    question: "Can I book a cab after completing my Goa holiday?",
    answer: "Yes, you can arrange your return cab in advance by providing your Goa pickup location, travel date, preferred departure time, and Pune destination."
  },
  {
    question: "How can I book a Goa to Pune Cab?",
    answer: "Share your Goa pickup point, Pune drop location, travel date, passenger count, luggage details, and preferred vehicle with Garud Cab Service to arrange your booking."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Sawant",
    feedback: "After our Goa vacation, we booked a private cab to Pune. The pickup from our resort was convenient and the vehicle gave our family plenty of comfort for the return journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Neha Bhosale",
    feedback: "I needed to return from Goa to Pune after a short business trip. Garud Cab Service made the booking simple and the private journey was much more convenient than changing transport.",
    rating: 5
  }
];











  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Goa to Pune Cabs",
  "image": "https://garudcabs.com/assets/images/goa-to-pune-cabs.webp",
  "description": "Book reliable Goa to Pune Cabs with Garud Cab for safe, comfortable, and convenient intercity travel. Get one way and round trip taxi services from Goa to Pune with Sedan, Ertiga, SUV, Innova, and Innova Crysta options, suitable for family travel, business trips, airport transfers, and long-distance journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/goa-to-pune-cabs"
  }
};


  return (
    <div>


<Helmet>
  <title>Goa to Pune Cabs | One Way Taxi & Cab Service | +91 9970007784</title>

  <meta
    name="description"
    content="Book Goa to Pune Cabs with Garud Cab for comfortable and reliable intercity travel. Get one way and round trip taxi services with Sedan, Ertiga, SUV, Innova, and Innova Crysta options at competitive Goa to Pune cab fares."
  />

  <meta
    name="keywords"
    content="Goa to Pune cab, Goa to Pune cab service, Goa to Pune one way cab, Goa to Pune taxi, Goa to Pune cab price, Goa Pune cab service, Goa to Pune car rental, Goa to Pune taxi fare, Goa to Pune cab booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/13.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Goatopunecab;